import { atom } from "recoil";

export const refetchBrandAtomState = atom({
    key: 'c398f7c5-1791-464b-b285-4d7f968f61db', // unique ID (with respect to other atoms/selectors)
    default: { "brandRefetch": "" },
});
